import { SimpleTimeEntry } from './SimpleTimeEntry';

type ZeiterfassungWrapperProps = {
  selectedUserId: string | null;
  setSelectedUserId: React.Dispatch<React.SetStateAction<string | null>>;
};

export function ZeiterfassungWrapper({
  selectedUserId,
  setSelectedUserId,
}: ZeiterfassungWrapperProps) {
  return (
    <SimpleTimeEntry
      selectedUserId={selectedUserId}
      setSelectedUserId={setSelectedUserId}
    />
  );
}